import type { SVGProps } from 'react'

export const DrawerArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="18.1487" height="18.1487" rx="9.07434" fill="#EFE9E3" />
    <path
      d="M7.81311 5.77831L10.9817 8.94682L7.81311 12.1154"
      stroke="#4D122C"
      strokeWidth="1.07782"
      strokeLinecap="round"
    />
  </svg>
)
